import type { DrillGrade, DrillItem } from "./Drill";

// Первая задача серии без ответа; все решены — длина серии.
export const firstOpenIndex = (items: DrillItem[]): number => {
  const index = items.findIndex((item) => item.attempt === null);
  return index === -1 ? items.length : index;
};

export type SeriesScore = { right: number; close: number; wrong: number; points: number };

// Итог серии: «почти» засчитывается половиной.
export const seriesScore = (items: DrillItem[]): SeriesScore => {
  const count = (grade: DrillGrade) => items.filter((item) => item.attempt?.grade === grade).length;
  const right = count("right");
  const close = count("close");
  return { right, close, wrong: count("wrong"), points: right + close / 2 };
};
